/* @generated */

// ../src/chip/chip.tsx
import { StylelessButton } from "@dropbox/dig-components/buttons";
import * as React4 from "react";
import cls2 from "classnames";

// ../src/chip/accessory.tsx
import * as React2 from "react";
import cls from "classnames";

// ../src/chip/context.tsx
import * as React from "react";
var ChipContext = React.createContext(void 0);

// ../src/chip/accessory.tsx
import { _PrivateAvatarPropContext } from "@dropbox/dig-components/avatar";
import { IconContext } from "@dropbox/dig-icons";

// ../src/chip/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var chip = _7a468({ defaultClassName: "dig-13n6pq97_22-5-0", variantClassNames: { isSelected: { true: "dig-13n6pq98_22-5-0", false: "dig-13n6pq99_22-5-0" }, selectedStyle: { fill: "dig-13n6pq9a_22-5-0", stroke: "dig-13n6pq9b_22-5-0" }, isSelectable: { true: "dig-13n6pq9c_22-5-0", false: "dig-13n6pq9d_22-5-0" }, variant: { standard: "dig-13n6pq9e_22-5-0", attention: "dig-13n6pq9f_22-5-0", success: "dig-13n6pq9g_22-5-0", warning: "dig-13n6pq9h_22-5-0", transparent: "dig-13n6pq9i_22-5-0", alert: "dig-13n6pq9j_22-5-0" }, size: { xsmall: "dig-13n6pq9k_22-5-0", small: "dig-13n6pq9l_22-5-0", medium: "dig-13n6pq9m_22-5-0" } }, defaultVariants: {}, compoundVariants: [[{ isSelected: true, variant: "standard", selectedStyle: "fill" }, "dig-13n6pq9n_22-5-0"], [{ isSelected: true, variant: "standard", selectedStyle: "stroke" }, "dig-13n6pq9o_22-5-0"], [{ isSelected: true, variant: "attention", selectedStyle: "fill" }, "dig-13n6pq9p_22-5-0"], [{ isSelected: true, variant: "attention", selectedStyle: "stroke" }, "dig-13n6pq9q_22-5-0"], [{ isSelected: true, variant: "success", selectedStyle: "fill" }, "dig-13n6pq9r_22-5-0"], [{ isSelected: true, variant: "success", selectedStyle: "stroke" }, "dig-13n6pq9s_22-5-0"], [{ isSelected: true, variant: "warning", selectedStyle: "fill" }, "dig-13n6pq9t_22-5-0"], [{ isSelected: true, variant: "warning", selectedStyle: "stroke" }, "dig-13n6pq9u_22-5-0"], [{ isSelected: true, variant: "transparent", selectedStyle: "fill" }, "dig-13n6pq9v_22-5-0"], [{ isSelected: true, variant: "transparent", selectedStyle: "stroke" }, "dig-13n6pq9w_22-5-0"], [{ isSelected: true, variant: "alert", selectedStyle: "fill" }, "dig-13n6pq9x_22-5-0"], [{ isSelected: true, variant: "alert", selectedStyle: "stroke" }, "dig-13n6pq9y_22-5-0"]] });
var chipAvatarAccessory = "dig-13n6pq911_22-5-0";
var chipContent = "dig-13n6pq9z_22-5-0";
var chipItem = "dig-13n6pq910_22-5-0";
var chipRemoveButton = _7a468({ defaultClassName: "dig-13n6pq913_22-5-0", variantClassNames: { isDisabled: { true: "dig-13n6pq914_22-5-0", false: "dig-13n6pq915_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var chipRemoveIcon = "dig-13n6pq916_22-5-0";

// ../src/chip/accessory.tsx
import { atoms } from "@dropbox/dig-foundations";
var Accessory = ({ className, children }) => {
  return /* @__PURE__ */ React2.createElement("div", { className: cls(className, "dig-Chip-item", chipItem, "dig-Chip-accessory") }, children);
};
Accessory.displayName = "Chip.Accessory";
var IconAccessory = ({ className, children }) => {
  return /* @__PURE__ */ React2.createElement(
    IconContext.Provider,
    {
      value: {
        UIIconOverrides: {
          size: "small",
          isOpticallyAligned: true
        }
      }
    },
    /* @__PURE__ */ React2.createElement(Accessory, { className: cls("dig-Chip-accessory--isIcon", atoms({ display: "flex" }), className) }, children)
  );
};
IconAccessory.displayName = "Chip.IconAccessory";
var AvatarAccessory = ({ children, className }) => {
  const ctx = React2.useContext(ChipContext);
  const avatarSize = ctx && ["small", DEPRECATED_CHIP_SIZE_XSMALL2].includes(ctx.size) ? "xsmall" : "small";
  return /* @__PURE__ */ React2.createElement(
    _PrivateAvatarPropContext.Provider,
    {
      value: { hasNoOutline: true, size: avatarSize, isInactive: ctx && ctx.isDisabled }
    },
    /* @__PURE__ */ React2.createElement(Accessory, { className: cls(className, chipAvatarAccessory, "dig-Chip-accessory--isAvatar") }, children)
  );
};
AvatarAccessory.displayName = "Chip.AvatarAccessory";

// ../src/chip/chip.tsx
import { UIIcon } from "@dropbox/dig-icons";
import { ChevronDownLine, CloseLine } from "@dropbox/dig-icons/assets";

// ../src/_global/constants.ts
var DELETE_KEY = "Delete";
var BACKSPACE_KEY = "Backspace";
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = `[${buttonDataAttributeName}]`;
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = `[${buttonContentDataAttributeName}]`;
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = `[${splitButtonDataAttributeName}]`;
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = `[${iconButtonDataAttributeName}]`;

// ../src/chip/compatibility.tsx
import * as React3 from "react";
var _PrivateCompatibilityContext = React3.createContext({
  /**
   * The old chip component supported an `xsmall` size, which the new `Chip` does not. We don't want to allow consumers
   * to use this size, but we do want to support it for backwards compatibility. This flag is used to explicitly tell
   * the new `Chip` component to render in an xsmall size.
   */
  isXSmall: false
});

// ../src/chip/chip.tsx
var DEFAULT_CHIP_SIZE = "medium";
var DEPRECATED_CHIP_SIZE_XSMALL2 = "xsmall";
var ChipContent = ({ children, className }) => {
  return /* @__PURE__ */ React4.createElement("div", { className: cls2("dig-Chip-item", chipItem, "dig-Chip-content", chipContent, className) }, children);
};
ChipContent.displayName = "ChipContent";
var ChipRef = React4.forwardRef(
  ({
    className,
    size: _size = DEFAULT_CHIP_SIZE,
    variant = "standard",
    children,
    isSelected = false,
    selectedStyle = "fill",
    withDropdownIcon = false,
    onDelete,
    disabled,
    "aria-disabled": ariaDisabled,
    onKeyUp,
    onClick,
    ...rest
  }, ref) => {
    const isRemovable = !!onDelete;
    const isDisabled = !!(disabled || ariaDisabled);
    const shouldBindKeyUp = !!(onKeyUp || onDelete);
    const compat = React4.useContext(_PrivateCompatibilityContext);
    const size = React4.useMemo(() => {
      if (compat.isXSmall) {
        return DEPRECATED_CHIP_SIZE_XSMALL2;
      }
      return _size;
    }, [_size, compat]);
    const contextValue = {
      size,
      isDisabled
    };
    const handleKeyUp = (e) => {
      if (onDelete && (e.key === DELETE_KEY || e.key === BACKSPACE_KEY)) {
        onDelete();
      }
      if (onKeyUp) {
        onKeyUp(e);
      }
    };
    const handleClickCloseIcon = (e) => {
      e.stopPropagation();
      if (onDelete) {
        onDelete();
      }
    };
    const isSelectable = !!onClick && !isDisabled;
    return /* @__PURE__ */ React4.createElement(ChipContext.Provider, { value: contextValue }, /* @__PURE__ */ React4.createElement(
      StylelessButton,
      {
        ...rest,
        disabled,
        "aria-disabled": isDisabled ? "true" : void 0,
        "aria-pressed": isSelected ? "true" : "false",
        ref,
        onClick: !isDisabled ? onClick : void 0,
        onKeyUp: shouldBindKeyUp ? handleKeyUp : void 0,
        className: cls2(
          "dig-Chip",
          `dig-Chip--size-${size}`,
          `dig-Chip--${variant}`,
          className,
          chip({ isSelectable, isSelected, variant, selectedStyle, size }),
          {
            [`dig-Chip--isSelected`]: isSelected,
            [`dig-Chip--isSelected-${selectedStyle}`]: isSelected,
            [`dig-Chip--isRemovable`]: isRemovable,
            [`dig-Chip--isSelectable`]: isSelectable,
            [`dig-Chip--isDisabled`]: isDisabled
          }
        )
      },
      children,
      withDropdownIcon && /* @__PURE__ */ React4.createElement(IconAccessory, null, /* @__PURE__ */ React4.createElement(UIIcon, { src: ChevronDownLine, size: "small" })),
      isRemovable && /* @__PURE__ */ React4.createElement(IconAccessory, null, /* @__PURE__ */ React4.createElement(
        "div",
        {
          onClick: !isDisabled ? handleClickCloseIcon : void 0,
          className: cls2("dig-Chip-remove-button", chipRemoveButton({ isDisabled }), {
            [`dig-Chip-remove-button--isDisabled`]: isDisabled
          }),
          "data-testid": "digInputChipCloseIcon"
        },
        /* @__PURE__ */ React4.createElement(
          UIIcon,
          {
            size: "small",
            className: cls2("dig-Chip-item-remove-icon", chipRemoveIcon),
            src: CloseLine
          }
        )
      ))
    ));
  }
);
ChipRef.displayName = "Chip";
var Chip = Object.assign({}, ChipRef, {
  Content: ChipContent,
  IconAccessory,
  AvatarAccessory
});
export {
  AvatarAccessory,
  Chip,
  DEFAULT_CHIP_SIZE,
  DEPRECATED_CHIP_SIZE_XSMALL2 as DEPRECATED_CHIP_SIZE_XSMALL,
  IconAccessory,
  _PrivateCompatibilityContext
};
